import React, { useState } from 'react';
import { Box, Button, Heading, Layer, Select } from 'grommet';
import { Close } from 'grommet-icons';
import PropTypes from 'prop-types';
import { API } from '@enrich/shared-lib';

export const ProgramStatusButton = ({
    contactId,
    currentStatus,
    revalidate,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [buttonBusy, setButtonBusy] = useState(false);
    const [programStatuses, setProgramStatuses] = useState([]);

    const handleClick = async () => {
        setButtonBusy(true);
        const response = await getProgramStatuses();
        setProgramStatuses(response);
        setShowModal(true);
        setButtonBusy(false);
    };

    return (
        <Box>
            <Button
                secondary
                size="large"
                label="Update program status"
                onClick={handleClick}
                busy={buttonBusy}
            />
            {showModal && (
                <ProgramStatusModal
                    contactId={contactId}
                    currentStatus={currentStatus}
                    programStatuses={programStatuses}
                    revalidate={revalidate}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const ProgramStatusModal = ({
    contactId,
    currentStatus,
    programStatuses,
    revalidate,
    setShowModal,
}) => {
    const [selectedStatus, setSelectedStatus] = useState();
    const [buttonBusy, setButtonBusy] = useState(false);

    const updateStatus = async () => {
        try {
            setButtonBusy(true);
            await API.put(
                `/api/contacts/${contactId}/update-program-status`,
                { data: { enrichProgramStatus: selectedStatus } },
            );
            revalidate();
            setShowModal(false);
        } catch (error) {
            setButtonBusy(false);
            console.log(error);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Update program status
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => {
                                setShowModal(false);
                            }}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box gap="small">
                    <Box align="center">
                        (current status is {currentStatus})
                    </Box>
                    <Box
                        width="medium"
                        align="center"
                        round="6px"
                        background="white">
                        <Select
                            options={programStatuses}
                            onChange={({ option }) => setSelectedStatus(option)}
                            value={selectedStatus}
                        />
                    </Box>
                </Box>
                <Box></Box>
                <Box>
                    <Button
                        primary
                        busy={buttonBusy}
                        disabled={!selectedStatus}
                        label="Save"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={updateStatus}
                    />
                </Box>
            </Box>
        </Layer>
    );
};

ProgramStatusButton.propTypes = {
    contactId: PropTypes.string,
    currentStatus: PropTypes.string,
    revalidate: PropTypes.func,
};

ProgramStatusModal.propTypes = {
    contactId: PropTypes.string,
    currentStatus: PropTypes.string,
    programStatuses: PropTypes.array,
    revalidate: PropTypes.func,
    setShowModal: PropTypes.func,
};

async function getProgramStatuses() {
    try {
        const response = await API.get('/api/program-statuses');
        return response.data.data.map((status) => status.attributes.name);
    } catch (error) {
        console.log(error);
        return [];
    }
}
